import { SortDirection } from '../../components/ui/Table';

interface Props {
  size?: number;
  color?: string;
  dir?: SortDirection;
}

const SortIcon = (props: Props) => {
  const { color = '#000', size = 25, dir } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}>
      {(!dir || dir === 'desc') && (
        <path
          d="M14.8491 15.75V5.25M14.8491 5.25L18.3491 8.85938M14.8491 5.25L11.3491 8.85938"
          stroke={color}
          strokeWidth={1.3125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {(!dir || dir === 'asc') && (
        <path
          d="M7.84912 5.25V15.75M7.84912 15.75L11.3491 12.1406M7.84912 15.75L4.34912 12.1406"
          stroke={color}
          strokeWidth={1.3125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

export default SortIcon;
